import React from 'react';
import CloseButton from '../../../components/buttons/CloseButton';
import StepCommentsItem from './StepCommentsItem';
import StepAddComment from './StepAddComment';
import { useTranslation } from 'react-i18next';
import { ISingleOrderField } from '../types/interfaces';

export default function StepCommentsSidebar({
  sideRef,
  closeCommentsSide,
  field,
  canAddComment
}: {
  sideRef: React.RefObject<HTMLDivElement>;
  closeCommentsSide: () => void;
  field: ISingleOrderField | null;
  canAddComment: boolean;
}) {
  const { t, i18n } = useTranslation();

  return (
    <div className="comments-overlay">
      <div className="comments-side" ref={sideRef}>
        <div className="comments-side-header">
          <h4>{t('comments')}</h4>
          <CloseButton handleClose={closeCommentsSide} />
        </div>
        <div className="comments-side-categories">
          <div key={`comment-category`} className="comment-category">
            <h4 className="comment-category-title">{field?.label?.[i18n.language as 'en' | 'ar']}</h4>
            {canAddComment && <StepAddComment fieldId={field?.id} />}
            <div className="comments-list">
              {field?.comments?.length === 0 && (
                <div className="comment-empty">
                  <h4>{t('no_comments')}</h4>
                </div>
              )}
              {field?.comments?.map((comment) => <StepCommentsItem key={comment.id} comment={comment} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
